import React, { useMemo } from 'react';

// import { IconRawSvg } from 'components/IconRawSvg';
import { calcGradientByScore } from './services/calcGradeintByScore';
import styled from '@emotion/styled';
import { classNames } from '../../services/classNames';

export const KaiBubbleBackground: React.FC<any> = ({
    score,
    scoreLimit,
    className,
}) => {
    const gradientColors = useMemo(() => {
        return calcGradientByScore(score, scoreLimit);
    }, [score, scoreLimit]);

    if (!gradientColors || !gradientColors[0] || !gradientColors[1]) {
        return null;
    }

    return (
        <StyledKaiBubbleBackground
            className={classNames('KaiBubbleBackground', className)}
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="621"
                height="652.031"
                viewBox="0 0 621 652.031"
            >
                <defs>
                    <linearGradient
                        id="kai-bubble-outside-gradient"
                        x2="0"
                        y2="1"
                    >
                        <stop offset="0%" stopColor={`#${gradientColors[0]}`} />
                        <stop
                            offset="100%"
                            stopColor={`#${gradientColors[1]}`}
                        />
                    </linearGradient>
                    <linearGradient id="kai-bubble_svg__a" x2="0" y2="1">
                        <stop offset="0%" stopColor="#54ef93" />
                        <stop offset="100%" stopColor="#15d8e2" />
                    </linearGradient>
                    <linearGradient id="kai-bubble_svg__b" x2="1" y2="0">
                        <stop
                            offset="0%"
                            stopColor="#ffffff"
                            stopOpacity="0.5"
                        />
                        <stop
                            offset="10%"
                            stopColor="#ffffff"
                            stopOpacity="0"
                        />
                        <stop
                            offset="90%"
                            stopColor="#ffffff"
                            stopOpacity="0"
                        />
                        <stop
                            offset="100%"
                            stopColor="#ffffff"
                            stopOpacity="0.5"
                        />
                    </linearGradient>
                </defs>
                <path
                    className="kai-bubble_svg__kai-color-gradient"
                    data-name="Ellipse 1 copy 12"
                    fill="url(#kai-bubble_svg__a)"
                    d="M1266.26 505.861c-2.25 43.156-21.85 73.923-44.02 105.576-22.67 31.1-47.9 63.082-73.13 95.914-51.38 64.16-101.49 134.467-187.517 137.342-85.13 4.215-167.4-33.521-219.392-84.254-52.332-51.031-88.14-127.724-95.31-214.875-6.129-90.466 19.584-176.489 73.51-240.041 53.378-63.792 134.97-105.112 227.96-111.714 93.279-5.938 169.119 20.3 223.909 75.083 27.71 27.676 51.14 63.423 68.84 105.278 17.36 41.477 29 89.063 25.15 131.691z"
                    transform="translate(-646 -192.969)"
                />
                <path
                    data-name="Ellipse 1 copy 15"
                    fill="url(#kai-bubble_svg__b)"
                    d="M1231.01 508.085c-2 38.38-19.41 65.742-39.09 93.892-20.14 27.656-42.55 56.1-64.95 85.3-45.64 57.059-90.15 119.585-166.555 122.142-75.609 3.749-148.679-29.812-194.857-74.93-46.481-45.383-78.284-113.589-84.652-191.094-5.443-80.454 17.394-156.958 65.294-213.476 47.41-56.732 119.878-93.479 202.468-99.351 82.847-5.28 150.207 18.051 198.867 66.774 24.61 24.613 45.42 56.4 61.15 93.626 15.42 36.887 25.76 79.206 22.33 117.117z"
                    transform="translate(-646 -192.969)"
                />
                <path
                    data-name="Ellipse 1 copy 14"
                    fill="url(#kai-bubble_svg__b)"
                    d="M1266.26 505.861c-2.25 43.156-21.85 73.923-44.02 105.576-22.67 31.1-47.9 63.082-73.13 95.914-51.38 64.16-101.49 134.467-187.517 137.342-85.13 4.215-167.4-33.521-219.392-84.254-52.332-51.031-88.14-127.724-95.31-214.875-6.129-90.466 19.584-176.489 73.51-240.041 53.378-63.792 134.97-105.112 227.96-111.714 93.279-5.938 169.119 20.3 223.909 75.083 27.71 27.676 51.14 63.423 68.84 105.278 17.36 41.477 29 89.063 25.15 131.691z"
                    transform="translate(-646 -192.969)"
                />
            </svg>
        </StyledKaiBubbleBackground>
    );
};

const StyledKaiBubbleBackground = styled.div`
    .kai-bubble_svg__kai-color-gradient {
        transition: fill 500ms ease;

        fill: url(#kai-bubble-outside-gradient);
    }
`;
